import fetch from "auth/FetchInterceptor";

const ataService = {};

ataService.get = function (params = {}) {
	return fetch({
		url: "/v1/rest/ata",
		method: "get",
		params,
	});
};

ataService.post = function (data) {
	return fetch({
		url: "/v1/rest/ata",
		method: "post",
		data: data,
	});
};

ataService.put = function (id, data) {
	return fetch({
		url: `/v1/rest/ata/${id}`,
		method: "put",
		data: data,
	});
};

ataService.getById = function (id) {
	return fetch({
		url: `/v1/rest/ata/${id}`,
		method: "get",
	});
};

ataService.delete = function (id) {
	return fetch({
		url: "/v1/rest/ata/" + id,
		method: "delete",
	});
};

export default ataService;
